var _style, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLuminaireLightFixture({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "16.2px",
    height: "16.1px",
    viewBox: "0 0 16.2 16.1",
    style: {
      enableBackground: "new 0 0 16.2 16.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Luminaire Light Fixture") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 4.9,
    className: "st0",
    width: 0.5,
    height: 5.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 7.4,
    className: "st0",
    width: 15.1,
    height: 0.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.7,
    y: 4.9,
    className: "st0",
    width: 0.5,
    height: 5.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuminaireLightFixture);
export default __webpack_public_path__ + "static/media/LuminaireLightFixture.22d69c2b996aa644af60c2123fe550c1.svg";
export { ForwardRef as ReactComponent };